import { render, staticRenderFns } from "./NewVendorDetails.vue?vue&type=template&id=7855500e&"
import script from "./NewVendorDetails.vue?vue&type=script&lang=js&"
export * from "./NewVendorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports